import SuratJalanDeliveryDetail from '@/models/SuratJalanDelivery/SuratJalanDeliveryDetail';

export default class SuratJalanDeliveryDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.suratJalanDeliveryId  = '';
		this.suratJalanDeliverySuratJalanNumber = '';
		this.deliveryCardId  = '';
		this.deliveryCardDeliveryCardNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.orderQty = '';
		this.deliveryQty = '';
		this.isLoading = false;
		this.deliveryInstructionDetailId  = '';
		this.deliveryInstructionDetailPart = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			suratJalanDeliveryId : '0',
			suratJalanDeliverySuratJalanNumber : '0',
			deliveryCardId : '0',
			deliveryCardDeliveryCardNumber : '0',
			partId : '0',
			partPartNumber : '0',
			orderQty : '0',
			deliveryQty : '0',
			isLoading : '0',
			deliveryInstructionDetailId : '0',
			deliveryInstructionDetailPart : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}